// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { rfqQuoteDetailsSalesRepProductListStyles } from "@conklin/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsSalesRepProductList";
import { hideElement, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsSalesRepProductListStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

rfqQuoteDetailsSalesRepProductListStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

rfqQuoteDetailsSalesRepProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingStyles = {
    row: {
        mergeCss: true,
        evenRowCss: css`
            background: transparent;
        `,
        css: css`
            border: none;
            &&& {
                padding-left: 0;
            }
        `,
    },
    quantityCell: {
        css: css`
            border: none;
            height: 18px;
            vertical-align: top;
            padding: 0 8px 0 0;
            display: flex;
            align-items: baseline;
        `,
    },
    priceCell: {
        css: css`
            border: none;
            height: 18px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    priceWithoutVatCell: {
        css: css`
            border: none;
            height: 30px;
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.uomHeadingAndText = {
    heading: {
        weight: "bold",
        size: 12,
        css: css`
            ${hideElement}
        `,
    },
    text: {
        css: css`
            padding-left: 6px;
            white-space: nowrap;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quotedPricingContainer = {
    css: css`
        display: flex;
        align-items: flex-start;
        padding-top: 3px;
        > div {
            display: inline-block;
            width: auto;
        }
        > div:first-child {
            display: inline-block;
            width: auto;
            max-width: 140px;
        }

        ${xScreen("lte", "md")} {
            > div:first-child {
                display: inline-block;
                width: auto;
                max-width: 100%;
            }
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.buttonContainer = {
    css: css`
        display: flex;
        justify-content: flex-end;
        button {
            min-height: 32px;
        }
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.countValueText = {
    variant: "h3",
};

rfqQuoteDetailsSalesRepProductListStyles.countLabelText = {
    variant: "h3",
    css: css`
        margin-left: 5px;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.headerWrapper = {
    css: css`
        padding-bottom: 15px;
    `,
};

rfqQuoteDetailsSalesRepProductListStyles.cartLineContainerStyles = {
    container: {
        css: css`
            padding-right: 0;
            padding-left: 0;
            gap: 0;
        `,
    },
    description: {
        css: css`
            padding-left: 10px;
        `,
    },
    inventory: {
        css: css`
            margin-right: 10px;
            padding-top: 0;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 4;
                grid-row: 3 / 4;
            }
            ${xScreen("lte", "xs")} {
                grid-column: 1 / 6;
                padding-bottom: 16px;
            }
        `,
    },
    qty: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 4 / 6;
                grid-row: 3 / 4;
                margin-right: 20px;
            }
            ${xScreen("lte", "xs")} {
                grid-column: 1 / 3;
                grid-row: 4 / 5;
                padding-bottom: 5px;
            }
        `,
    },
    total: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 6 / 7;
                grid-row: 3 / 4;
            }
            ${xScreen("lte", "xs")} {
                grid-column: 3 / 7;
                grid-row: 4 / 5;
            }
        `,
    },
    actions: {
        css: css`
            padding-left: 10px;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.linesHeader = {
    wrapper: {
        css: css`
            padding-right: 0;
            padding-left: 0;
            gap: 0;
        `,
    },
    itemDescription: {
        css: css`
            padding-left: 12px;
        `,
    },
};

rfqQuoteDetailsSalesRepProductListStyles.quoteLineButton = {};
